import React from "react";
import { Box, Button, Column, Columns } from "@allxsmith/bestax-bulma";
import {readableDate} from "../../../utils";

export default function QuoteItem({quote, onDuplicate}){

    return (
        <Columns isMultiline>
            <Column>
                <Box>
                    <Columns isMultiline>
                        <Column>
                            <h2 className={"bold"}>Quote - {quote.id} - {quote.department ? quote.department.name : ""}</h2>
                        </Column>
                        <Column>
                            <p>Duplicate - {quote.duplicate ? "Yes" : "No"}</p>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <p>Customer 1 - {quote.customer ? quote.customer.display_name : ""}</p>
                        </Column>
                        <Column>
                            <p>Customer 2 - {quote.customer2 ? quote.customer2.display_name : ""}</p>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <p>Provisional Start Date - {readableDate(quote.provisional_start_date)}</p>
                        </Column>
                        <Column>
                            <p>Description - {quote.description}</p>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={() => onDuplicate(quote)}
                            >
                                Duplicate
                            </Button>
                        </Column>
                    </Columns>
                </Box>
            </Column>
        </Columns>
    );


}